// socialLinks.js
export const socialLinks = [
  {
    id: 'twitter',
    name: 'Twitter',
    defaultUrl: '',
    icon: 'Twitter'
  },
  {
    id: 'instagram',
    name: 'Instagram',
    defaultUrl: '',
    icon: 'Instagram'
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    defaultUrl: '',
    icon: 'Linkedin'
  },
  {
    id: 'github',
    name: 'GitHub',
    defaultUrl: '',
    icon: 'Github'
  },
  {
    id: 'youtube',
    name: 'YouTube',
    defaultUrl: '',
    icon: 'Youtube'
  },
  {
    id: 'facebook',
    name: 'Facebook',
    defaultUrl: '',
    icon: 'Facebook'
  },
  {
    id: 'gmail',
    name: 'Gmail',
    defaultUrl: '', // For Gmail, no default URL; user will enter an email address.
    icon: 'Mail'
  }
];
